document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('compare-table-container');
  if (!container) return;

  init();

  function getStoredList() {
    try {
      return JSON.parse(localStorage.getItem('compareProducts')) || [];
    } catch (e) {
      return [];
    }
  }

  function getStoredHandles() {
    return getStoredList().map((p) => p.handle);
  }

  // Keep the ?items= query string in sync with localStorage so a reload
  // (or a copied/shared link) always reflects the current list.
  function updateUrlParams(handles) {
    const url = new URL(window.location.href);
    if (handles.length) {
      url.searchParams.set('items', handles.join(','));
    } else {
      url.searchParams.delete('items');
    }
    window.history.replaceState({}, '', url);
  }

  function currentHandles() {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('items');
    return fromUrl ? fromUrl.split(',').filter(Boolean) : getStoredHandles();
  }

  async function init() {
    const handles = currentHandles();

    if (handles.length === 0) {
      container.innerHTML =
        '<p class="compare-empty">No products selected yet. Browse the store and click "Compare" on products you\'d like to line up side by side.</p>';
      return;
    }

    container.innerHTML = '<p class="compare-loading">Loading comparison...</p>';

    try {
      const products = await Promise.all(
        handles.map((h) => fetch(`/products/${h}.js`).then((r) => r.json()))
      );
      renderTable(products);
    } catch (err) {
      container.innerHTML = '<p>Sorry, something went wrong loading these products.</p>';
    }
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Works whether or not the global CompareProducts instance loaded on this
  // page, so it isn't dependent on the floating-bar snippet being present.
  function removeProduct(handle) {
    if (window.compareProductsInstance) {
      window.compareProductsInstance.remove(handle);
    } else {
      const list = getStoredList().filter((p) => p.handle !== handle);
      localStorage.setItem('compareProducts', JSON.stringify(list));
    }
    updateUrlParams(getStoredHandles());
    init(); // re-render in place, no full page reload
  }

  function clearAll() {
    if (window.compareProductsInstance) {
      window.compareProductsInstance.clear();
    } else {
      localStorage.setItem('compareProducts', JSON.stringify([]));
    }
    updateUrlParams([]);
    init();
  }

  function renderTable(products) {
    // Each row definition: a label + a function that renders that row's value per product.
    // Add/remove rows here to control what shows up in the comparison.
    const rows = [
      {
        label: '',
        render: (p) => `<img src="${p.featured_image}" alt="${p.title}" width="140" loading="lazy">`,
      },
      {
        label: 'Product',
        render: (p) => `<a href="/products/${p.handle}"><strong>${p.title}</strong></a>`,
      },
      { label: 'Price', render: (p) => formatMoney(p.price) },
      { label: 'Vendor', render: (p) => p.vendor || '—' },
      { label: 'Type', render: (p) => p.type || '—' },
      {
        label: 'Availability',
        render: (p) => (p.available ? 'In stock' : 'Out of stock'),
      },
      {
        label: 'Description',
        render: (p) => `<div class="compare-table__desc">${stripHtml(p.description).slice(0, 220)}${p.description.length > 220 ? '…' : ''}</div>`,
      },
    ];

    // Wrapped in .compare-table-scroll so the table can scroll horizontally
    // on mobile instead of squeezing columns or overflowing the page.
    let html = '<div class="compare-table-scroll"><table class="compare-table"><tbody>';

    rows.forEach((row) => {
      html += `<tr><th>${row.label}</th>`;
      products.forEach((p) => {
        html += `<td>${row.render(p)}</td>`;
      });
      html += '</tr>';
    });

    html += '<tr><th></th>';
    products.forEach((p) => {
      html += `<td><button type="button" data-compare-remove="${p.handle}" class="compare-table__remove">Remove</button></td>`;
    });
    html += '</tr></tbody></table></div>';

    html +=
      '<div class="compare-table__footer"><button type="button" data-compare-clear-page class="compare-table__clear">Clear all</button></div>';

    container.innerHTML = html;

    // Removing a product from the table also updates the floating bar/localStorage
    container.querySelectorAll('[data-compare-remove]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation(); // avoid double-handling with the global bar listener
        removeProduct(btn.dataset.compareRemove);
      });
    });

    const clearBtn = container.querySelector('[data-compare-clear-page]');
    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        clearAll();
      });
    }
  }
});